export class JobShipmentInfoEntity {
  shipmentId!: string
  position!: number
  orderId!: string
  orderReferenceCode!: string
}
